<template>
  <div>
    <b-button squared @click="ver = true" variant="success">+ viaje</b-button>

    <b-modal @show="nuevo" no-close-on-backdrop size="lg" v-model="ver">
      <template #modal-header> Agregar Viaje </template>

      <b-form-group :description="Revisar">
        <date-picker :disabled-date="disableDate" placeholder="Fecha del viaje" v-model="fecha" class="w-100" id="fecha" valueType="date"></date-picker>
      </b-form-group>

      <b-input-group v-show="fecha" class="my-2">
        <b-form-select class="form-control" :options="RegOrigen" v-model="Origen">
          <template #first>
            <b-form-select-option :value="null" disabled>
              -- Region origen --
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-input-group>

      <b-input-group v-show="Origen" class="my-2">
        <b-form-select class="form-control" :options="RegDestino" v-model="Destino">
          <template #first>
            <b-form-select-option :value="null" disabled>
              -- Region Destino --
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-input-group>

      <template #modal-footer>
        <b-button @click="ver = false" size="sm" squared variant="primary">Cerrar</b-button>
        <b-overlay :show="esperar">
          <b-button :disabled="!aplicar" @click="onGuardarViaje" size="sm" squared variant="success">Guardar</b-button>
        </b-overlay>
      </template>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

let ayer = new Date();
ayer.setDate(ayer.getDate() - 1);

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  watch: {
    Origen() {
      this.Destino = null;
    },
  },
  computed: {
    Revisar() {
      let f = this.fecha;

      let rs = this.Viajes.filter((item) => {
        return new Date(item.fecha) - f == 0;
      });

      if (rs.length > 0) {
        return `La fecha tiene viaje, ${rs[0].origen} => ${rs[0].destino}  `;
      } else return "";
    },
    aplicar() {
      let rs = false;
      rs = !!this.Destino || false;

      return rs;
    },
    Viajar() {
      let rs = {
        origen: this.Origen?.Codigo || "",
        destino: this.Destino?.Codigo || "",
        fecha: this.fecha || "",
        precio: this.Origen?.Precio || "",
      };

      return rs;
    },
    RegOrigen() {
      let rs = this.Paises.map((p) => {
        return {
          label: p.Nombre,
          options: p.Regiones.map((r) => {
            return { value: { Codigo: r.Codigo, Precio: p.Precio, Id: p.id }, text: r.Nombre };
          }),
        };
      });
      return rs;
    },
    RegDestino() {
      let _id = this.Origen?.Id || false;
      if (_id) {
        let paises = this.Paises.filter((item) => item.id != _id);

        let rs = paises.map((p) => {
          return {
            label: p.Nombre,
            options: p.Regiones.map((r) => {
              return { value: { Codigo: r.Codigo, Precio: p.Precio, Id: p.id }, text: r.Nombre };
            }),
          };
        });

        return rs;
      } else {
        return this.RegOrigen;
      }
    },
  },

  components: { DatePicker },
  methods: {
    nuevo() {
      this.fecha = null;
      this.Origen = null;
      this.Destino = null;
      this.esperar = false;
      this.Viajes = JSON.parse(localStorage.Viajes);
    },
    onGuardarViaje() {
      let self = this;
      self.esperar = true;
      let v = { ...this.Viajar };
      db.collection("Viaje")
        .add(v)
        .then(() => {

          localStorage.removeItem('Viajes');
          localStorage.removeItem('fechaViajes');

          self.esperar = false;
          self.ver = false;
        });
    },
    disableDate(date) {
      return date < ayer;
    },
  },
  data() {
    return {
      fecha: null,
      ver: false,
      Origen: null,
      Destino: null,
      Paises: [],
      esperar: false,
      Viajes: [],
    };
  },
  firestore: {
    Paises: db.collection("Pais"),
  },
};
</script>
